import React, { Fragment } from 'react'

import { RoutesManager } from 'utils/routing/routesManager'
import { NavigationBreadCrumbs } from 'components/appLayout/appNavigation/breadcrumbs/NavigationBreadCrumbs'
import { Box, Typography } from '@mui/material'
import { ContentGroup, InfoRow } from '@ketch-com/deck'
import { EmptyValueRenderer } from 'components/EmptyValueRenderer'
import { usePurposeViewContext } from 'pages/policyCenter/purposes/view/context/PurposeViewContext'

export const PurposesTabDisplay: React.FC = () => {
  const { purpose, organizationLanguages: languagesList } = usePurposeViewContext()

  return (
    <>
      <NavigationBreadCrumbs
        type="dark"
        items={[
          { title: 'Privacy Program', link: RoutesManager.policyCenter.root.getURL() },
          { title: 'Purposes', link: RoutesManager.policyCenter.purposes.root.getURL() },
          {
            title: purpose?.name || purpose?.code,
            link: RoutesManager.policyCenter.purposes.view.root.getURL({ code: purpose?.code || '' }),
          },
          { title: 'Display' },
        ]}
      />
      <Box display="flex" flexDirection="column" gap={4} mb={6}>
        <ContentGroup title="Display" titleVariant="h3" variant="inner-page-header" />
        <InfoRow title="Display Name">
          {purpose?.displayName ? <Typography>{purpose.displayName}</Typography> : <EmptyValueRenderer />}
        </InfoRow>
        <InfoRow title="Display Description">
          {purpose?.displayDescription ? (
            <Typography
              sx={{ whiteSpaceCollapse: 'break-spaces' }} /*added whiteSpaceCollapse style to fix bug KD-12825*/
            >
              {purpose.displayDescription}
            </Typography>
          ) : (
            <EmptyValueRenderer />
          )}
        </InfoRow>
      </Box>
      <Box display="flex" flexDirection="column" gap={4} mb={6}>
        <ContentGroup title="Translations" titleVariant="h3" variant="inner-page-header" />
        {languagesList.map((item, _) => (
          <Fragment key={item.language.code}>
            <ContentGroup
              titleVariant="h3"
              variant="inner-page-header"
              titleCustomComponent={
                <Typography variant="h4" color="darkGrey.main">
                  {item.language.englishName}
                </Typography>
              }
            />
            <InfoRow title="Display Name">
              {purpose?.translations?.[item.language.code]?.displayName ? (
                <Typography>{purpose?.translations?.[item.language.code]?.displayName}</Typography>
              ) : (
                <EmptyValueRenderer />
              )}
            </InfoRow>
            <InfoRow title="Display Description">
              {purpose?.translations?.[item.language.code]?.displayDescription ? (
                <Typography>{purpose?.translations?.[item.language.code]?.displayDescription}</Typography>
              ) : (
                <EmptyValueRenderer />
              )}
            </InfoRow>
          </Fragment>
        ))}
      </Box>
    </>
  )
}
